import { CommonSettingsContext } from '@starsoft/common/context';
import { CommonSettingsContextProps } from '@starsoft/common/context/CommonSettings/props';
import { useContext } from 'react';

/**
 * Custom hook to access the settings store context.
 * This hook provides access to the common settings context, which contains various settings and configurations.
 *
 * @returns {CommonSettingsContextProps} The context object containing settings and configurations.
 *
 * @throws {Error} If the hook is used outside of a SettingsProvider.
 *
 * @example
 * // Usage example:
 * const settings = useSettingsStore();
 */
export function useSettingsStore(): CommonSettingsContextProps {
  // Get the context object from the CommonSettingsContext
  const context: CommonSettingsContextProps = useContext(CommonSettingsContext);

  // If the context is not available, throw an error
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }

  // Return the context object
  return context;
}
